import { mapActions } from "../reducer";

import { MapState } from '../../types';

export const setInitializedMap = (
  value: MapState['initialized']
) => mapActions.setInitializedMap(value);
